import { l } from 'ui/lib/lodashImports'

/*
	turns chains of break characters to a single space
 */
export const ensureSingleSpace = (string: string): string =>
	l.replace(string, /\s+/g, ' ')
